import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import NewsListSection from './components/NewsListSection';
import CTASection from '../home/components/CTASection';
import { updatePageSEO } from '../../utils/seo';

const NewsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    updatePageSEO({
      title: 'お知らせ | おかやま整形外科 - 最新情報・診療案内',
      description: 'おかやま整形外科からのお知らせ。休診日のご案内、診療時間の変更、新しい治療法の導入、健康セミナーの開催情報など、最新情報をお届けします。',
      keywords: 'お知らせ, 最新情報, 診療案内, 休診日, おかやま整形外科',
      canonical: `${siteUrl}/news`,
      structuredData: {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'お知らせ',
        description: 'おかやま整形外科からの最新情報とお知らせ',
        url: `${siteUrl}/news`,
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'ホーム',
              item: `${siteUrl}/`
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'お知らせ',
              item: `${siteUrl}/news`
            }
          ]
        }
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <HeroSection />
        <NewsListSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default NewsPage;
